module.exports = __webpack_public_path__ + "img/reward-give-icon-ug.ef6436bc.png";